import { Box } from "@material-ui/core";
import { Typography, styled } from "@mui/material";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

const CustomTurnoInIndiaCard = styled(Box)(({ theme }) => ({
  ".turno-in-india-card": {
    background: "#FEF8E6",
    borderRadius: "16px",
    width: "375px",
    img: {
      width: "100%",
    },
    ".details": {
      padding: "10px 32px",
      ".title": {
        fontSize: "20px",
        lineHeight: "30px",
        fontWeight: "700",
        color: "#000",
      },
      ".date": {
        fontSize: "16px",
        lineHeight: "67px",
        fontWeight: "600",
        color: "#8A8787",
      },
      ".description": {
        fontSize: "20px",
        lineHeight: "30px",
        fontWeight: "500",
        color: "#000",
      },
      ".read-more": {
        fontSize: "16px",
        lineHeight: "66px",
        fontWeight: "600",
        color: "#8A8787",
        textAlign: "center",
      },
    },
  },
  [theme.breakpoints.down("md")]: {
    ".turno-in-india-card": {
      width: "230px",
      // height: "380px",
      img: {
        width: "100%",
      },
      ".details": {
        padding: "10px 32px",
        ".title": {
          fontSize: "14px",
          lineHeight: "18px",
        },
        ".date": {
          fontSize: "8px",
          lineHeight: "30px",
        },
        ".description": {
          fontSize: "12px",
          lineHeight: "14px",
        },
        ".read-more": {
          fontSize: "8px",
          lineHeight: "66px",
        },
      },
    },
  },
}));

const TurnoInIndiaCard = ({ details }) => {
  return (
    <CustomTurnoInIndiaCard>
      <Box className="turno-in-india-card">
        <LazyLoadImage
          src={details?.image}
          alt={details?.altText}
          effect="opacity"
        />
        <Box className="details">
          <Typography className="title">{details?.title}</Typography>
          <Typography className="date">{details?.date}</Typography>
          <Typography className="description">
            {details?.description}
          </Typography>
          {/* <Typography className="read-more">Read more {">>"}</Typography> */}
        </Box>
      </Box>
    </CustomTurnoInIndiaCard>
  );
};
export default TurnoInIndiaCard;
